import { ThreadEntityType } from '@enums/thread-entity-type.enum';

export const THREAD_ENTITY_TYPE_LABEL: Record<ThreadEntityType, string> = {
  [ThreadEntityType.accountingPeriod]: 'Exercice',
  [ThreadEntityType.vatDeclaration]: 'TVA',
  [ThreadEntityType.task]: 'Mission complémentaire',
  [ThreadEntityType.bankTransaction]: 'Transaction',
  [ThreadEntityType.corporateTaxInstalment]: "Acompte d'IS"
};
